export default function ({ store, redirect }) {
  if (!!store.state.jobSeekerFairOccupationRequired === false)
    return redirect('/ocupaciones-requeridas/cesantes')
}
